package fr.frux.feature.site.detail

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

/**
 * « 24/10/2026 à 14:30 », fuseau de l'appareil. Doublon assumé de `formatHarvestDateTime`
 * (feature-harvest-detail) : une feature ne dépend pas d'une autre (#658).
 */
@OptIn(ExperimentalTime::class)
internal fun formatSiteHarvestDate(epochMillis: Long): String {
    val dt = Instant.fromEpochMilliseconds(epochMillis).toLocalDateTime(TimeZone.currentSystemDefault())
    val day = dt.day.toString().padStart(2, '0')
    val month = (dt.month.ordinal + 1).toString().padStart(2, '0')
    val hour = dt.hour.toString().padStart(2, '0')
    val minute = dt.minute.toString().padStart(2, '0')
    return "$day/$month/${dt.year} à $hour:$minute"
}
